import validate from "/var/www/frontend/releases/20260716174406/node_modules/nuxt/dist/pages/runtime/validate.js";
import add_45trailing_45slash_45global from "/var/www/frontend/releases/20260716174406/middleware/addTrailingSlash.global.ts";
import auth_45global from "/var/www/frontend/releases/20260716174406/middleware/auth.global.ts";
import check_45telegram_45global from "/var/www/frontend/releases/20260716174406/middleware/check-telegram.global.ts";
import detect_45device_45global from "/var/www/frontend/releases/20260716174406/middleware/detectDevice.global.ts";
import ios_45pwa_45installer_45opener_45global from "/var/www/frontend/releases/20260716174406/middleware/ios-pwa-Installer-opener.global.ts";
import page_45animation_45global from "/var/www/frontend/releases/20260716174406/middleware/page-animation.global.ts";
import redirect_45global from "/var/www/frontend/releases/20260716174406/middleware/redirect.global.ts";
import categoriesMiddleware from "/var/www/frontend/releases/20260716174406/modules/categories/middleware/categoriesMiddleware.global.ts";
import menuMiddleware from "/var/www/frontend/releases/20260716174406/modules/menu/middleware/menuMiddleware.global.ts";
import trackRouteNavigationTabBar from "/var/www/frontend/releases/20260716174406/modules/tabBar/middleware/routeTracker.global.ts";
import manifest_45route_45rule from "/var/www/frontend/releases/20260716174406/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  add_45trailing_45slash_45global,
  auth_45global,
  check_45telegram_45global,
  detect_45device_45global,
  ios_45pwa_45installer_45opener_45global,
  page_45animation_45global,
  redirect_45global,
  categoriesMiddleware,
  menuMiddleware,
  trackRouteNavigationTabBar,
  manifest_45route_45rule
]
export const namedMiddleware = {
  catch: () => import("/var/www/frontend/releases/20260716174406/middleware/catch.ts")
}